module.exports = __webpack_public_path__ + "static/img/人员睡岗识别.109911ee.png";